import queryString from 'query-string';

const ABSOLUTE_URL_REGEX = /^([a-z][\d+.a-z-]*:)?\/\//i;
const isAbsoluteURL = (url) => ABSOLUTE_URL_REGEX.test(url);
function getParamValueFromUrl(url, param) {
  return new URL(url).searchParams.get(param) ?? "";
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? `${baseURL.replace(/\/?\/$/, "")}/${relativeURL.replace(/^\/+/, "")}` : baseURL;
}
function buildURL(url, params) {
  if (!params) {
    return url;
  }
  let result;
  const serializedParams = params instanceof URLSearchParams ? params.toString() : queryString.stringify(params);
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      result = url.slice(0, hashmarkIndex);
    }
    result += (url.includes("?") ? "&" : "?") + serializedParams;
  }
  return result;
}

export { buildURL, combineURLs, getParamValueFromUrl, isAbsoluteURL };
//# sourceMappingURL=index.js.map
